export default __webpack_public_path__ + "static/media/outside-company.71a93cb7.svg";